import { createContext, useContext, useState, useCallback, useRef } from "react";

const UnsavedGuardContext = createContext(null);

export const UnsavedGuardProvider = ({ children }) => {
  const dirtyRef = useRef(false);
  const [pending, setPending] = useState(null); // { onProceed: () => void }

  const setDirty = useCallback((v) => { dirtyRef.current = !!v; }, []);

  const attemptNavigate = useCallback((onProceed) => {
    if (dirtyRef.current) {
      setPending({ onProceed });
      return false;
    }
    onProceed();
    return true;
  }, []);

  const proceed = useCallback(() => {
    const p = pending;
    dirtyRef.current = false;
    setPending(null);
    if (p) p.onProceed();
  }, [pending]);

  const cancel = useCallback(() => setPending(null), []);

  return (
    <UnsavedGuardContext.Provider value={{ setDirty, pending, attemptNavigate, proceed, cancel }}>
      {children}
    </UnsavedGuardContext.Provider>
  );
};

export const useUnsavedGuard = () => {
  const ctx = useContext(UnsavedGuardContext);
  if (!ctx) throw new Error("useUnsavedGuard must be used within UnsavedGuardProvider");
  return ctx;
};
